<div
  class="bg-white dark:bg-gray-900 max-w-md w-full p-6 text-gray-800 dark:text-white backdrop-blur-xl rounded-2xl shadow-2xl relative"
>
  <!-- Close Button -->
  <button
    (click)="onClose()"
    class="absolute top-4 right-4 p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/5 transition-colors cursor-pointer text-gray-400"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>

  <div class="space-y-6">
    <div class="text-center pb-2">
      <h2
        class="text-2xl font-black bg-linear-to-r from-red-600 to-orange-600 bg-clip-text text-transparent italic"
      >
        {{ "REPORT_MODAL.TITLE" | translate }}
      </h2>
      <p
        class="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-widest mt-1"
      >
        {{ "REPORT_MODAL.SUBTITLE" | translate }}
      </p>
    </div>

    @if (isSuccess()) {
      <div
        class="py-8 text-center space-y-4 animate-in fade-in zoom-in duration-300"
      >
        <div
          class="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-green-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="3"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h3 class="text-xl font-bold text-gray-800 dark:text-white">
          {{ "REPORT_MODAL.SUCCESS_TITLE" | translate }}
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ "REPORT_MODAL.SUCCESS_DESC" | translate }}
        </p>
      </div>
    } @else {
      <!-- Content Preview -->
      <div
        class="p-4 bg-slate-200 dark:bg-gray-800 rounded-xl border border-dashed border-gray-400 dark:border-gray-600"
      >
        <p
          class="text-xs text-gray-500 dark:text-gray-400 uppercase font-bold mb-1"
        >
          {{ "REPORT_MODAL.REPORTED_CONTENT_LABEL" | translate }}
        </p>
        <p
          class="text-sm font-semibold truncate text-gray-700 dark:text-gray-200"
        >
          {{ data.displayName }}
        </p>
      </div>

      <!-- Reporting Form -->
      <form (ngSubmit)="onSubmit()" class="space-y-4">
        <div class="space-y-1">
          <label
            for="reason"
            class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase ml-1"
            >{{ "REPORT_MODAL.REASON_LABEL" | translate }}</label
          >
          <select
            id="reason"
            name="reason"
            [ngModel]="selectedReason()"
            (ngModelChange)="selectedReason.set($event)"
            required
            class="w-full p-3 bg-white dark:bg-gray-800 dark:text-white border border-gray-300 dark:border-gray-600 rounded-xl text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all cursor-pointer"
          >
            <option value="" disabled>
              {{ "REPORT_MODAL.REASON_PLACEHOLDER" | translate }}
            </option>
            @for (reason of reasons; track reason.value) {
              <option [value]="reason.value">
                {{ reason.label | translate }}
              </option>
            }
          </select>
        </div>

        <div class="space-y-1">
          <label
            for="description"
            class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase ml-1"
            >{{ "REPORT_MODAL.DESCRIPTION_LABEL" | translate }}</label
          >
          <textarea
            id="description"
            name="description"
            [ngModel]="description()"
            (ngModelChange)="description.set($event)"
            rows="3"
            class="w-full p-3 bg-white dark:bg-gray-800 dark:text-white border border-gray-300 dark:border-gray-600 rounded-xl text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all resize-none"
            placeholder="{{
              'REPORT_MODAL.DESCRIPTION_PLACEHOLDER' | translate
            }}"
          ></textarea>
        </div>

        <app-alert [message]="errorMessage()" class="mt-2" />

        <div class="pt-2">
          <button
            type="submit"
            [disabled]="!selectedReason() || isLoading()"
            class="w-full py-4 bg-linear-to-r from-red-600 to-orange-600 text-white rounded-xl font-black italic tracking-wider shadow-lg hover:shadow-red-500/20 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer uppercase"
          >
            <div class="flex items-center justify-center gap-2">
              @if (isLoading()) {
                <svg
                  class="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>{{ "REPORT_MODAL.BUTTON_LOADING" | translate }}</span>
              } @else {
                <span>{{ "REPORT_MODAL.BUTTON" | translate }}</span>
              }
            </div>
          </button>
        </div>
      </form>
    }
  </div>
</div>
